<div class="component-container">
  <div class="component-header">
    <h2>Countries Setup</h2>
  </div>
  <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Countries">
      <app-country-list></app-country-list>
    </mat-tab>

    <mat-tab label="Nationalities">
      <app-nationality-list></app-nationality-list>
    </mat-tab>

    <mat-tab label="Currencies">
      <app-currency-list></app-currency-list>
    </mat-tab>

    <mat-tab label="Stock Exchanges">
      <app-stock-exchange-list></app-stock-exchange-list>
    </mat-tab>
  </mat-tab-group>
</div>




